export const itemImgaeWidth = 345;

export const itemImageHeight = 230; // it was 250

export const imageAllowedSizeInMB = 1;
